import React, { createContext, useContext } from 'react';
import type { CampaignCardProps } from './types';

const initialValue: CampaignCardProps = {
  id: undefined,
  handleCardOnClick: () => null,
  handleClickOut: () => null,
  name: undefined,
  rating: undefined,
  reviewsCount: undefined,
  price: {
    id: undefined,
    price: undefined,
    previousPrice: undefined,
    previousPriceText: undefined,
  },
  offerPrice: {
    endDate: undefined,
    memberPrice: undefined,
    originalPrice: undefined,
  },
  diffPercentage: undefined,
  internalLink: undefined,
  externalLink: undefined,
  category: { name: undefined },
  image: undefined,
  stockStatus: undefined,
  store: {
    id: 0,
    name: '',
    hasLogo: false,
    featured: false,
  },
  storeCount: undefined,
};
const CampaignCardContext = createContext<CampaignCardProps>(initialValue);

export const useCampaignCardContext = () => useContext(CampaignCardContext);

export const CampaignCardContextContainer: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<CampaignCardProps>>
> = props => {
  return (
    <CampaignCardContext.Provider value={props}>
      {props.children}
    </CampaignCardContext.Provider>
  );
};
